module.exports = __webpack_public_path__ + "img/denmark_bg.fb5c134.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countries/denmark_bg.jpeg
// module id = aBUC
// module chunks = 1